
const oauthPreAuthCodeKey = '__OAUTH2_PRE_AUTH_CODE_KEY__'; // i.e. code
const oauthRedirectUri = '__OAUTH2_REDIRECT_URI__'; // e.g. https://sales.eAssets.forestryengland.uk/login
const oauthUserAuthorizationUri = '__OAUTH2_USER_AUTH_URI__'; // e.g. https://forestry.onelogin.com/oidc/2/auth
const oauthClientId = '__OAUTH2_CLIENT_ID__'; // onelogin client id

export const environment = {
  production: true,
  appVersion: '__APP_VERSION__',
  appVersionVisible: '__APP_VERSION_VISIBLE__',
  apiUrl: '__API_URL__',
  preAuthCodeKey: null,
  jwtPreAuthCodeKey: 'Authorization',
  jwtCookiePreAuthCodeKey: 'AuthorizationCookie',
  appendAuthTokenHttpParams: false,
  tokenExpiryWarningMillis: (1000 * 60 * 5),
  externalLoginUrl: null,
  routingHistoryImplicitMode: true,
  routingHistoryEnabled: true,
  routingHistorySanitizeBrowserUrl: true,
  routingHistoryClearHistoryUrls: ['/', '/home'],
  navigateRouteOnLogoutSuccess: ['home'],
  superuserAuthority: 'IS_SUPERUSER',
  bannerImageAssetPathDefault: 'assets/Autumn_homepage.jpg',
  landingPages: {
    AdminLandingPageComponent: {
      bannerImageAssetPath: 'assets/LogStack_banner_2000518.jpg'
    },
    AssetsLandingPageComponent: {
      bannerImageAssetPath: 'assets/Winter_homepage.jpg'
    },
    FirearmsLandingPageComponent: {
      bannerImageAssetPath: 'assets/Winter_homepage.jpg'
    }
  },
  resetForgottenPasswordRequestSuccessMessage: "Password reset request successful. If valid, an email will be sent to the address provided."
};


if (oauthPreAuthCodeKey) {
  environment.preAuthCodeKey = oauthPreAuthCodeKey;
}
if (oauthUserAuthorizationUri && oauthRedirectUri && oauthClientId) {
  environment.externalLoginUrl = oauthUserAuthorizationUri + '?client_id=' + oauthClientId + '&redirect_uri=' + oauthRedirectUri + '&response_type=code&scope=openid';
}
